import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50b0ecbc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/image-input/image-input.scss?vue&type=style&index=0&id=50b0ecbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b0ecbc",
  null
  
)

export default component.exports